module.exports = __webpack_public_path__ + "media/newstyle/images/70-mil-authors-es-2b2cf57765b0e37df0423de1ece777ee.svg";